<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="시작기간"
            name="period"
            defaultStart="-6M"
            defaultEnd="6M"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="배치로그 이력"
          tableId="table"
          :columns="grid.columns"
          :data="grid.data"
          @linkClick="linkClick"
          :columnSetting="false"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'batch-log',
  data() {
    return {
      grid: {
        columns: [
        // {
        //   name: 'batchHisId',
        //   field: 'batchHisId',
        //   label: '',
        //   align: 'center',
        //   sortable: true,
        // },
        // {
        //   name: 'batchClassName',
        //   field: 'batchClassName',
        //   label: '',
        //   align: 'center',
        //   sortable: true,
        // },
        {
          name: 'batchName',
          field: 'batchName',
          label: '배치명',
          style: 'width: 100px',
          align: 'center',
          sortable: true,
        },
        {
          name: 'successYn',
          field: 'successYn',
          label: '성공여부',
          align: 'center',
          style: 'width: 70px',
          sortable: true,
        },
        {
          name: 'resultCnt',
          field: 'resultCnt',
          label: '성공 Count',
          style: 'width: 70px',
          align: 'center',
          sortable: true,
        },
        {
          name: 'exceptions',
          field: 'exceptions',
          label: '오류내용',
          style: 'width: 250px',
          align: 'center',
          sortable: true,
        },
        {
          name: 'startDt',
          field: 'startDt',
          label: '시작일시',
          style: 'width: 150px',
          align: 'center',
          sortable: true,
        },
        ],
        data: [],
      },
      searchParam: {
        startYmd: '',
        endYmd: '',
      },
      period: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
      consultUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.consultUrl = selectConfig.sys.log.batch.list.url;
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.consultUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
  }
};
</script>
